<template>
    <footer class="footer bg-light">
        <small class="footer-text">
        Corendon Airlines &copy; {{new Date().getFullYear()}} - All Rights Reserved.<br/>
        </small>
    </footer>
</template>

<script>
    export default {
        name: "AppFooter",
    }
</script>

<style scoped>
    .footer {
        text-align: center;
        position: relative;
        bottom: -180px;
        left: 0px;
        right: 0px;
        margin-bottom: 0px;
        padding: 1rem 1.5rem 1rem;
    }
    .footer-text{
      font-family: Helvetica, Arial;
      font-size: 16px;
      color: #ffffff;
    }
    .bg-light{
      background-color: #547388!important;
    }
    @media (max-width: 767px) {
      .footer{
        position: inherit;
      }
    }

</style>
